import { Injectable } from "@angular/core";

import { Store } from "@ngrx/store";
import {FilesService} from "../../../services/files/files.service";

export interface PixiServices {
  fileService?: FilesService;
  store?: Store;
}

@Injectable({
  providedIn: "root",
})
export class PixiService {
  pixiServices: PixiServices = {};
  constructor(
    private fileService: FilesService,
    private store: Store,
  ) {
    this.pixiServices.fileService = this.fileService;
    this.pixiServices.store = this.store;
  }

  getPixiServices(): PixiServices {
    return this.pixiServices;
  }

  // async createRenderer(canvas, dimensions: Vector2): Promise<PIXI.Renderer> {
  //   const opts = {
  //     resolution: 1,
  //     canvas: canvas,
  //     backgroundAlpha: 0,
  //     // backgroundColor: {r: 255, g: 0, b: 0, a: 0},
  //     // background: {r: 255, g: 0, b: 0, a: 0},
  //     width: dimensions.x,
  //     height: dimensions.y,
  //     preference: "webgpu",
  //     webgpu: {
  //       antialias: true,
  //     },
  //     webgl: {
  //       antialias: true,
  //     },
  //   } as any as PIXI.AutoDetectOptions;
  //   const renderer = await PIXI.autoDetectRenderer(opts);
  //   renderer.layout.enableDebug(true);
  //   const ls = new LayoutSystem();
  //   return renderer;
  // }
}
